<template>
  <div
    class="overlay"
    :class="{ 'bg-color': globalPopupState.props.selfClick }"
    aria-modal="true"
    role="dialog"
    tabindex="-1"
    @click.self="handleSelfClick"
  >
    <transition
      v-bind="globalPopupState.props.transition"
      @after-leave="closePopup"
      @enter-cancelled="closePopup"
    >
      <component
        :is="globalPopupState.component"
        v-if="globalPopupState.showContent"
        v-bind="globalPopupState.props"
        @action="onAction"
      />
    </transition>
  </div>
</template>

<script setup lang="ts">
const { closePopup, globalPopupState, toggleComponent } = usePopups();
function keydownListener(event: KeyboardEvent) {
  if (event.key === 'Escape')
  { toggleComponent(false); }
}
function handleSelfClick() {
  if (globalPopupState.props.selfClick)
  { toggleComponent(); }
}

onMounted(() => {
  if (import.meta.client) {
    document.addEventListener('keydown', keydownListener);
    toggleComponent();
  }
});

onUnmounted(() => {
  if (import.meta.client) {
    document.removeEventListener('keydown', keydownListener);
  }
});

function onAction() {
  if (globalPopupState.props.action) {
    globalPopupState.props.action();
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/animations.scss';

.slide-up-enter-from, .slide-up-leave-to {
  transform: translateY(-100%);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all .5s ease;
}

.slide-up-enter-to, .slide-up-leave-from {
  transform: translateY(0);
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;

  overflow: scroll;

  &.bg-color {
    background: rgba(17, 17, 19, 0.01);
  }

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
